"use strict";

require("../../style/index.less");

require("./index.less");

require("../../button/style");